<template>
  <!-- 罪名库 -->
  <div id="zuiming">
    <section><zuiminmenu /></section>
    <section><zuimingcont /></section>

  </div>
</template>

<script>

import zuiminmenu from "./child/zuiminmenu";
import zuimingcont from "./child/zuimingcont";

export default {
  name: "zuiming",
  components: {
    // 私
    zuiminmenu,
    zuimingcont,

  },
};
</script>

<style lang="scss" scoped>
#zuiming {
  background-color: #f8f8f8;

}
</style>
